import React from 'react';
import Box from '../../../../components/Box';
import './ReportHeader.css';

const ReportHeader = ({ data, teamId }) => (
  <Box className="scout-report-header"
    title={
      <div>
        { data.teamLogo &&
          <div className="team-logo pull-left">
            <img
              src={ data.teamLogo }
              alt={ data.teamName }/>
          </div>
        }
        <div className="s4u-logo pull-right">
          <img src="https://s4ucontent.s3.amazonaws.com/images/header.png"
               alt="Scouting4U.com"/>
        </div>
        <h3 className="box-title">
          <span>{ data.teamName }</span>
        </h3>
        <div>
          <span>{ data.leagueName } </span>
          <span>{ data.seasonName }</span>
        </div>
        <h3 className="box-title text-uppercase">
          Scout Report
        </h3>
      </div>
    }>
  </Box>
);

export default ReportHeader;



// WEBPACK FOOTER //
// ./src/features/scout-report/components/ReportHeader/ReportHeader.js